import './landingPage.scss';

import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {fetchFacets, search, searchResetFacetsAction} from '../search/duck/search-actions';
import {SearchPageType} from '../search/search-config';
import {useTranslation} from 'react-i18next';
import {SearchBar} from '../search/search-bar/searchBar';
import {useHistory} from 'react-router-dom';

export const LandingPage = React.memo(() => {
    const searchPageType = SearchPageType.BASIC;

    const dispatch = useDispatch();
    const {t} = useTranslation();
    const history = useHistory();

    const triggerSearch = useCallback((searchExpression: string) => {
        dispatch(searchResetFacetsAction(SearchPageType.BASIC));
        dispatch(search(searchPageType, history, searchExpression));
        dispatch(fetchFacets(searchPageType, searchExpression));
        // dependencies stay constant, avoid unnecessary re-renders
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const bgImageUrl: string = process.env.PUBLIC_URL + '/images/landing.jpg';
    const bgColor1: string = getComputedStyle(document.documentElement).getPropertyValue('--hibuGradientColor1');
    const bgColor2: string = getComputedStyle(document.documentElement).getPropertyValue('--hibuGradientColor2');
    const bgColor3: string = getComputedStyle(document.documentElement).getPropertyValue('--hibuGradientColor3');

    return (
        <div id={'landing-page'}>
            <div id="gradient-background" style={{
                backgroundImage: `linear-gradient(130deg, ${bgColor1} 0%, ${bgColor2} 64%, ${bgColor3} 100%), url('${bgImageUrl}')`
            }}/>
            <SearchBar
                placeholder={t('search.label.placeholder')}
                onSubmit={triggerSearch}
                initialValue={String('')}
            />
        </div>
    );
});
